"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getCounterUtilityClass = getCounterUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getCounterUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('OriMuiCounter', slot);
}
const counterClasses = (0, _base.generateUtilityClasses)('OriMuiCounter', ['root', 'input', 'focused', 'disabled', 'readOnly', 'iconButton', 'increaseButton', 'decreaseButton', 'sizeLarge', 'sizeMedium', 'colorDefault', 'colorPrimary', 'variantContained', 'variantOutlined', 'variantText', 'containedDefaultLarge', 'containedDefaultMedium', 'containedPrimaryLarge', 'containedPrimaryMedium', 'textDefaultLarge', 'textDefaultMedium', 'textPrimaryLarge', 'textPrimaryMedium', 'outlinedDefaultLarge', 'outlinedDefaultMedium', 'outlinedPrimaryLarge', 'outlinedPrimaryMedium', 'containedDefault', 'containedPrimary', 'outlinedDefault', 'outlinedPrimary', 'textDefault', 'textPrimary']);
var _default = exports.default = counterClasses;
